import { Category } from '../api/types';

/** sort_order «в конец» для типа: max(sort_order по type) + 10; пусто → 10. */
export function nextSortToEnd(cats: Category[], type: Category['type']): number {
  const ofType = cats.filter((c) => c.type === type);
  if (ofType.length === 0) return 10;
  const max = Math.max(...ofType.map((c) => c.sort_order));
  return max + 10;
}

/** Свап соседних элементов; за границей — вернуть исходный массив (тот же ref). */
export function swapAdjacent<T>(list: T[], index: number, dir: -1 | 1): T[] {
  const target = index + dir;
  if (target < 0 || target >= list.length) return list;
  const next = list.slice();
  next[index] = list[target];
  next[target] = list[index];
  return next;
}

/** Пересчёт sort_order от позиции с шагом 10: [(i+1)*10, ...],
 *  ТОЛЬКО для категорий, у которых sort_order изменился. */
export function renumberChanged(ordered: Category[]): { name: string; sort_order: number }[] {
  const result: { name: string; sort_order: number }[] = [];
  for (let i = 0; i < ordered.length; i++) {
    const expected = (i + 1) * 10;
    if (ordered[i].sort_order !== expected) {
      result.push({ name: ordered[i].name, sort_order: expected });
    }
  }
  return result;
}
